// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"39523cbe","215":"52b39057","727":"453c4ec6","793":"8360c0bc"}[chunkId] + ".chunk.css";
};